import Loadable, { NullLoader } from '@comeon/loadable';

// Make all the containers loadable under single chunk.

const SportsbookBrowsePageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-browse-page" */
			'./sportsbook-browse-page-container'
		),
	loading: NullLoader
});

const SportsbookBrowseSportsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-browse-page" */
			'./sportsbook-browse-sports-container'
		),
	loading: NullLoader
});

const SportsbookBrowseLeaguesContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-browse-page" */
			'./sportsbook-browse-leagues-container'
		),
	loading: NullLoader
});

export { SportsbookBrowsePageContainer, SportsbookBrowseSportsContainer, SportsbookBrowseLeaguesContainer };
